@if (app) {
  <div>
    <dl class="govuk-summary-list">
      <div class="govuk-summary-list__row">
        <dt class="govuk-summary-list__key">Id</dt>
        <dd class="govuk-summary-list__value">{{app.id}}</dd>
      </div>
      @if (app.name) {
        <div class="govuk-summary-list__row">
          <dt class="govuk-summary-list__key"> Name </dt>
          <dd class="govuk-summary-list__value"> {{app.name}} </dd>
        </div>
      }
      @if (app.version) {
        <div class="govuk-summary-list__row">
          <dt class="govuk-summary-list__key">Version</dt>
          <dd class="govuk-summary-list__value"> {{app.version}} </dd>
        </div>
      }
      @if (app.description) {
        <div class="govuk-summary-list__row">
          <dt class="govuk-summary-list__key">Description </dt>
          <dd class="govuk-summary-list__value"> {{app.description}} </dd>
        </div>
      }
      @if (app.category) {
        <div class="govuk-summary-list__row">
          <dt class="govuk-summary-list__key">Category</dt>
          <dd class="govuk-summary-list__value"> {{app.category}} </dd>
        </div>
      }
      @if (app.deploymentId) {
        <div class="govuk-summary-list__row">
          <dt class="govuk-summary-list__key">Deployment id</dt>
          <dd class="govuk-summary-list__value"> {{app.deploymentId}} </dd>
        </div>
      }
      @if (app.processDeployments) {
        <div class="govuk-summary-list__row">
          <dt class="govuk-summary-list__key">Child deployment ids</dt>
          @for (dep of app.processDeployments; track dep; let i = $index) {
            <dd class="govuk-summary-list__value"> {{dep.id}} </dd>
          }
        </div>
      }
    </dl>
    @if (app.resources) {
      <table class="govuk-table">
        <caption class="govuk-heading-m govuk-table__caption">Resources included</caption>
        <thead class="govuk-table__head">
          <tr class="govuk-table__row">
            <th scope="col" class="govuk-table__header"></th>
            <th scope="col" class="govuk-table__header">Name</th>
            <th scope="col" class="govuk-table__header">Media type</th>
            <th scope="col" class="govuk-table__header">Type</th>
            <th scope="col" class="govuk-table__header">&nbsp;</th>
          </tr>
        </thead>
        <tbody class="govuk-table__body">
          @for (resource of app.resources; track resource; let i = $index) {
            <tr class="govuk-table__row">
              <td class="govuk-table__header">{{i+1}}</td>
              <td class="govuk-table__cell">{{resource.id}}</td>
              <td class="govuk-table__cell">{{resource.mediaType}}</td>
              <td class="govuk-table__cell">{{resource.type}}</td>
              <td class="govuk-table__cell">
                @for (id of resource.contentIds; track id) {
                  <span>
                    <button class="govuk-button" data-module="govuk-button" [routerLink]="['/proc-defs/proc-def-detail', id]">
                      View details
                    </button>
                  </span>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
    <div class="govuk-button-group">
      <button class="govuk-button" data-module="govuk-button" [routerLink]="['/apps']">
        Back to list
      </button>
      <button class="govuk-button govuk-button--warning" data-module="govuk-button" (click)="onDelete(app)">
        Delete app
      </button>
    </div>
  </div>
}
